

export interface DeleteProps {
    title?: string
    message?: string
    warnText?: string
    confirm?: string
}

export const audioBeepSound = (): HTMLAudioElement => {
    const beepAudioId = '_audio_beep_sound_';
    const audioFile = `/audio/beeps.mp3`;
    let audio = document.getElementById(beepAudioId) as HTMLAudioElement | null;
 
    if (!audio) {
        const audioSource = document.createElement('source');
        audioSource.src = audioFile;
        audioSource.type = 'audio/mpeg';

        audio = document.createElement('audio');
        audio.id = beepAudioId;
        audio.style.display = 'none';
        audio.style.opacity = '0';
        audio.appendChild(audioSource);

        document.body.appendChild(audio);
    }

    return audio;
}